import { render, staticRenderFns } from "./_tabTerms&conditions.vue?vue&type=template&id=5e527bf0&"
import script from "./_tabTerms&conditions.vue?vue&type=script&lang=js&"
export * from "./_tabTerms&conditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports